import { Card, CardHeader, Divider, Typography } from "@mui/material";
import { RolesList } from "../../../components";

interface IProps {
  userGuid: string;
}

const RolesReview = (props: IProps) => {
  return (
    <Card>
      <CardHeader title={<Typography variant="h6">Roles Review</Typography>} />
      <Divider />
      <RolesList userId={props.userGuid} />
    </Card>
  );
};

export { RolesReview };
